<ng-container *ngIf="isLoading; else learnings">
  <span *ngIf="showSearchLayoutRedesign" class="h4">{{
    'UserController_Loading' | translate
  }}</span>
  <dgx-skeleton
    *ngFor="let _ of [].constructor(20)"
    type="search-result-card"
    data-dgat="search-learnings-953"
  ></dgx-skeleton>
</ng-container>

<ng-template #learnings>
  <ul class="guts-m-t-2">
    <li
      *ngFor="let result of results; index as i; trackBy: trackByFn"
      dgxIntersectionObserver
      (onIntersection)="onIntersectionOfResult(result, i)"
      data-dgat="search-learnings-b1e"
    >
      <dgx-learning-resource-card
        *ngIf="!showSearchLayoutRedesign"
        [resource]="result"
        [searchTerm]="searchTerm"
        [shouldTrackItemClicked]="false"
        (inputSelected)="onInputSelected($event, i)"
        [disableProviderLink]="showSearchLayoutRedesign"
        [attr.data-id]="trackByFn(i, result)"
      ></dgx-learning-resource-card>
      <dgx-search-result-card
        *ngIf="showSearchLayoutRedesign"
        [resource]="result"
        [searchTerm]="searchTerm"
        (inputSelected)="onInputSelected($event, i)"
        [attr.data-id]="trackByFn(i, result)"
        [searchResultTrackingConfig]="getSearchItemTrackingConfig(i)"
      ></dgx-search-result-card>
    </li>
  </ul>
</ng-template>
